import React, { FC, useState } from 'react';

import { track as trackLogRocket, TrackedEvent } from '@helpers/logRocket';
import { TextButton } from '@components/library/button';
import { WorkspaceCreateForm } from './WorkspaceCreateForm';

interface WorkspaceCreateButtonProps {
  atOverWorkspaceLimit: boolean;
  brandfolderSlug: string;
}

export const WorkspaceCreateButton: FC<WorkspaceCreateButtonProps> = ({ atOverWorkspaceLimit, brandfolderSlug }) => {
  const [isOpenDialog, setIsOpenDialog] = useState(false);

  const triggerMailTo = (): void => {
    const element = document.createElement('a');
    element.setAttribute('target', '_blank');
    element.setAttribute('href', `mailto:support@brandfolder.com?subject=Upgrade Inquiry&body=I'd like to inquire about adding more Workspaces to ${BFG.org_name}.`);
    element.style.display = 'none';

    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const handleClick = (): void => {
    if (atOverWorkspaceLimit) {
      triggerMailTo();
    } else {
      trackLogRocket(TrackedEvent.WorkspaceCreateOpen);
      setIsOpenDialog((prevState) => !prevState);
    }
  };

  return (
    <>
      <TextButton
        icon={atOverWorkspaceLimit ? undefined : 'bff-plus'}
        id="workspace-create-button"
        onClick={handleClick}
      >
        {atOverWorkspaceLimit ? bfTranslate('Upgrade for Workspaces') : bfTranslate('New Workspace')}
      </TextButton>
      <WorkspaceCreateForm
        brandfolderSlug={brandfolderSlug}
        isOpenDialog={isOpenDialog}
        setIsOpenDialog={setIsOpenDialog}
      />
    </>
  );
};
